import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/ShadersWGSL/meshUVSpaceRenderer.fragment.js
var name, shader, meshUVSpaceRendererPixelShaderWGSL;
var init_meshUVSpaceRenderer_fragment = __esm({
  "node_modules/@babylonjs/core/ShadersWGSL/meshUVSpaceRenderer.fragment.js"() {
    init_shaderStore();
    name = "meshUVSpaceRendererPixelShader";
    shader = `varying vDecalTC: vec2f;var textureSamplerSampler: sampler;var textureSampler: texture_2d<f32>;@fragment
fn main(input: FragmentInputs)->FragmentOutputs {if (input.vDecalTC.x<0. || input.vDecalTC.x>1. || input.vDecalTC.y<0. || input.vDecalTC.y>1.) {discard;}
fragmentOutputs.color=textureSample(textureSampler,textureSamplerSampler,input.vDecalTC);}
`;
    ShaderStore.ShadersStoreWGSL[name] = shader;
    meshUVSpaceRendererPixelShaderWGSL = { name, shader };
  }
});

export {
  meshUVSpaceRendererPixelShaderWGSL,
  init_meshUVSpaceRenderer_fragment
};
